import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { fmtDate } from "@/lib/format";
import { Bell, Mail, MessageSquare } from "lucide-react";

export default function AdminNotifications() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/notifications").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="admin-notifications">
      <div className="flex items-center gap-2 mb-1"><Bell className="text-[#c9a86a]" size={22} /><h1 className="text-2xl font-semibold">Notifications Log</h1></div>
      <p className="text-sm text-[var(--text-2)] mb-4">All emails & texts are <strong>placeholders</strong> (logged, not sent). Klaviyo / Twilio wiring is Phase 2.</p>
      <div className="space-y-2">
        {items.map((n) => (
          <Card key={n.id} className="p-4 border-[var(--border-lch)] flex items-start gap-3">
            <div className="p-2 rounded bg-[var(--panel-2)] text-[var(--text-2)]">{n.channel === "email" ? <Mail size={16} /> : <MessageSquare size={16} />}</div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2"><span className="font-medium text-sm">{n.subject || "(no subject)"}</span><Badge variant="outline" className="bg-amber-50 text-amber-700 text-[10px]">{n.status}</Badge></div>
              <div className="text-xs text-[var(--text-2)]">To: {n.to} · {fmtDate(n.created_at)}</div>
              <div className="text-sm text-[var(--text)] mt-1">{n.body}</div>
            </div>
          </Card>
        ))}
        {!items.length && <Card className="p-8 text-center text-[var(--muted)] border-[var(--border-lch)]">No notifications logged yet.</Card>}
      </div>
    </div>
  );
}
